<template>
    <div  id="screenshot">
        <div class="container q-mb-lg">
            <div class="row dropdownContainer">
                <div class="campaignDropDown col-5 row q-px-sm q-ml-sm">
                    <q-btn-dropdown class="col q-mr-sm q-mt-lg" :label="campaign_name">
                        <q-list>
                            <q-item clickable v-for="item in getCampaignItems" :key="item" v-close-popup
                                @click="setCampaignName(item)">
                                <q-item-section>
                                    <q-item-label>{{ item }}</q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-btn-dropdown>
                </div>
                <div class="col-4 q-mr-md">
                </div>
                <q-dialog v-model="seamless">
                    <q-card>
                        <q-card-section>
                            <div class="text-h6">Alert</div>
                        </q-card-section>
                        <q-card-section class="q-pt-none">
                            Mail has sent successfully!
                        </q-card-section>
                        <q-card-actions align="right">
                            <q-btn flat label="OK" color="primary" v-close-popup></q-btn>
                        </q-card-actions>
                    </q-card>
                </q-dialog>
                <div class="dateDropDown col q-mr-md q-mt-lg"
                    style="align-items: flex-end!important; display:flex!important;">
                    <q-input filled v-model="dateValue"
                        style="width:250px;background-color: white !important;box-shadow: 0px 4px 12px #00000033 !important;">
                        <template v-slot:append>
                            <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-date v-model="dateRange" :options="optionsFn" range
                                        @click="setDate(campaign_name)">
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Close" color="primary" flat />
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                </div>
            </div>
        </div>
        <!-- Apex Chart -->
        <div class="graphs row ">
            <div class='graph-1 col'>
                <h5 class="heading-z q-ml-region">Top 5 keywords moving sales</h5>
                <apexchart type="donut" height="350" :options="chartOptions1" :series="series1"></apexchart>
            </div>
            <div class="graph-1 col">
                <h5 class="heading-z">Top 5 keywords spending most</h5>
                <apexchart type=bar height=250 :options="chartOptions2" :series="series2" />
            </div>
            <div class="graph-1 col">
                <h5 class='heading-z'>ROAS score</h5>
                <apexchart type="radialBar" height=260 :options="chartOptions3" :series="series3" />
            </div>
        </div>
        <!-- table -->
        <div class="q-mt-lg">
            <q-table ref="table" v-model:pagination="pagination" :rows-per-page-options="[0]" hide-bottom
                class="my-sticky-header-table-1  q-ml-lg q-mr-lg " :data="rows1" separator="none" :columns="columns1"
                row-key="category">
                <template v-slot:header="props">
                    <q-tr :props="props" class="table-heading">
                        <q-th key="targetting" :props="props">
                            Targetting
                        </q-th>
                        <q-th key="impressions" :props="props">
                            <q-btn @click="sortItemsByProp('impressions')">Impressions</q-btn>
                        </q-th>
                        <q-th key="clicks" :props="props">
                            <q-btn @click="sortItemsByProp('clicks')">Clicks</q-btn>
                        </q-th>
                        <q-th key="cpc" :props="props">
                            <q-btn @click="sortItemsByProp('cpc')">CPC</q-btn>
                        </q-th>
                        <q-th key="sales" :props="props">
                            <q-btn @click="sortItemsByProp('adSales')">Sales</q-btn>
                        </q-th>
                        <q-th key="cost" :props="props">
                            <q-btn @click="sortItemsByProp('AdCost')">Cost</q-btn>
                        </q-th>
                        <q-th key="orders" :props="props">
                            <q-btn @click="sortItemsByProp('Orders')">Orders</q-btn>
                        </q-th>
                        <q-th key="unitssold" :props="props">
                            <q-btn @click="sortItemsByProp('unitsSold')">Units Sold</q-btn>
                        </q-th>
                        <q-th key="roas" :props="props">
                            <q-btn @click="sortItemsByProp('ROAS')">ROAS</q-btn>
                        </q-th>
                    </q-tr>
                </template>
                <template v-slot:body="props">
                    <q-tr v-for="(i,index) in  tableData.length" v-bind:key="i" :props="props" style="background-color:white">
                        <q-td key="targetting" :props="props">
                            {{ getEmailbasedTargetting(i) }}
                        </q-td>
                        <q-td key="impressions" :props="props">
                            {{ impressionsList[i - 1] }}
                        </q-td>
                        <q-td key="clicks" :props="props">
                            {{ clicksList[i - 1] }}
                        </q-td>
                        <q-td key="cpc" :props="props">
                            {{ cpcList[i - 1] }}
                        </q-td>
                        <q-td key="sales" :props="props">
                            {{ adSalesList[i - 1] }}
                        </q-td>
                        <q-td key="cost" :props="props">
                            {{ adcostList[i - 1] }}
                        </q-td>
                        <q-td key="orders" :props="props">
                            {{ ordersList[i - 1] }}
                        </q-td>
                        <q-td key="unitssold" :props="props">
                            {{ unitsSoldList[i - 1] }}
                        </q-td>
                        <q-td key="roas" :props="props">
                            {{ roasList[i - 1] }}
                        </q-td>
                    </q-tr>
                </template>
            </q-table>
        </div>
        <div style="margin-left:38%;" class="q-mt-sm q-mb-sm">
      <q-btn class="btn" style="background: #102689 0% 0% no-repeat padding-box;
                            border-radius: 5px;
                            color:white;
                            margin-right:1rem;" @click="generatePDF()">Generate Report</q-btn>
      <q-btn class="btn" style="background: #102689 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color:white;
                        margin-right:2rem;" @click="sendMail()">Mail Report</q-btn>
    </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { ref } from 'vue'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
export default {
    name: 'GaugeChart',
    name: 'BarExample',
    name: 'DonutExample',
    components: {
        apexchart: VueApexCharts
    },
    setup() {
        //date range in calender.Other dates will be blocked
        const dateRange = ref({ from: '01-01-2022', to: '05-1-2022' })
        return {
            dateRange,
            optionsFn(dateRange) {
                return dateRange >= this.min_date && dateRange <= this.max_date
            },
        }
    },
    data() {
        return {
            isAuthenticated: false,
            preview: false,
            api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
            chartData: 0,
            campaign_name: "all",
            date_list: [],
            impressions: 0,
            campaignName: "all",
            clicks: 0,
            dateValue: "",
            data_temp: [],
            clicksList: [],
            ordersList: [],
            impressionsList: [],
            adSalesList: [],
            cpcList: [],
            adcostList: [],
            unitsSoldList: [],
            keywordList: [],
            roasList: [],
            start_date: "",
            end_date: "",
            campaign: "",
            min_date: "",
            max_date: "",
            tableData: [],
            top5Keywords: [],
            top5cost: [],
            top5Keywords_sales: [],
            top5_sales: [],
            roas: 0,
            org_id: 0,
            clickCount: 0,
            seamless: false,
            //donut
            chartOptions1: {
                legend: {
                    position: 'bottom'
                },
            },
            series1: [],
            //bar
            series2: [{
                name: '',
                data: []
            }],
            chartOptions2: {
                chart: {
                    type: 'bar',
                },
                plotOptions: {
                    bar: {
                        borderRadius: 10,
                        horizontal: true,
                    }
                },
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    categories: [],
                }
            },
            series3: [],
            //gauge
            chartOptions3: {
                chart: {
                    height: 350,
                    type: "radialBar"
                },
                labels: [],
                plotOptions: {
                    radialBar: {
                        startAngle: -90,
                        endAngle: 90,
                        dataLabels: {
                            total: {
                                show: true,
                                label: "",
                                formatter: function () {
                                    return 0;
                                }
                            },
                        }
                    }
                }
            },
            columns1: [
                {
                    name: "targetting",
                    required: true,
                    label: "Targetting",
                    align: "center",
                    field: "targetting",
                },
                {
                    name: "impressions",
                    required: true,
                    label: "Impressions",
                    align: "center",
                    field: "impressions",
                },
                {
                    name: "clicks",
                    required: true,
                    label: "Clicks",
                    align: "center",
                    field: "clicks",
                },
                {
                    name: "cpc",
                    required: true,
                    label: "CPC",
                    align: "center",
                    field: "cpc",
                },
                {
                    name: "sales",
                    required: true,
                    label: "Sales",
                    align: "center",
                    field: "sales",
                },
                {
                    name: "cost",
                    required: true,
                    label: "Cost",
                    align: "center",
                    field: "cost",
                },
                {
                    name: "orders",
                    required: true,
                    label: "Orders",
                    align: "center",
                    field: "orders",
                },
                {
                    name: "unitssold",
                    required: true,
                    label: "Units Sold",
                    align: "center",
                    field: "unitssold",
                },
                {
                    name: "roas",
                    required: true,
                    label: "ROAS",
                    align: "center",
                    field: "roas",
                },
            ],
            rows1: [
                {},
            ],
        }
    },
    mounted() {
        this.$q.loading.show({
            message: "Authenticating please wait..",
        });
        if (this.$cookies.isKey("login_authentication")) {
            let encryptedText = this.$cookies.get("login_authentication");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: ", decryptedText);
            if (decryptedText == "authenticated") {
                this.$store.dispatch("setPathName", "/amazonadoptimization/adperfomacereports/keywordanalysis");
                this.$q.loading.hide();
                this.isAuthenticated = true;
                this.$q.loading.show({
                    message: "loading...",
                });
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else if (this.$cookies.isKey("login_authentication1")) {
            let encryptedText = this.$cookies.get("login_authentication1");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: ", decryptedText);
            if (decryptedText == "authenticated") {
                this.$store.dispatch("setPathName", "/amazonadoptimization/adperfomacereports/keywordanalysis");
                this.$q.loading.hide();
                this.isAuthenticated = true;
                this.$q.loading.show({
                    message: "loading...",
                });
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else if (this.$cookies.isKey("login_authentication2")) {
            let encryptedText = this.$cookies.get("login_authentication2");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: ", decryptedText);
            if (decryptedText == "authenticated") {
                this.$store.dispatch("setPathName", "/amazonadoptimization/adperfomacereports/keywordanalysis");
                this.$q.loading.hide();
                this.isAuthenticated = true;
                this.$q.loading.show({
                    message: "loading...",
                });
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else {
            this.$q.loading.hide();
            this.$router.push({
                name: "NotAuthenticated",
            });
            return;
        }
    },
    computed : {
    getCampaignItems() {
      const email = this.$store.state.credentials['attributes']['email'];
      // Check if the email is 'support@uniqin.ai'
      if (email === 'support@uniqin.ai') {
        // Return 'sample' instead of your data
        return ['sample'];
      } else {
        // Return your data based on your logic
        return this.campaignName; // Replace with your data source
      }
     
    },
    getmaskforgraph(){
        const email = this.$store.state.credentials['attributes']['email'];
      // Check if the email is 'support@uniqin.ai'
      if (email === 'support@uniqin.ai') {
        // Return 'sample' instead of your data
        return ['Targetting 1','Targetting 2','Targetting 3','Targetting 4','Targetting 5'];
      } else {
        return this.top5_sales.keywords;
      }
    },
    getmaskforseries2(data){
        return 'mask';
    }
    
    

    },
    created() {
        this.$q.loading.show({
            message: "Loading..",
        });
        var productsURL = this.api_url + "/dashboard/ad_dashbrd2_get_data";
        this.$http
            .post(productsURL, this.defaultCall())
            .then((response) => {
                if(response.data == null){
                    this.$router.push("/home/" + this.$org_encryprt.label);
                }
                this.data_temp = response.data;
                this.tableData = response.data['table_data'];
                let result = this.tableData;
                let top5cost = response.data['top_5_cost'];
                let top5_sales = response.data['top_5_sales'];
                this.dateRange.from = this.data_temp['min_date'];
                this.dateRange.to = this.data_temp['max_date'];
                var dateinput = this.dateRange.from.split("-");
                //changing format of date for range
                this.min_date = dateinput.join('/');
                var dateinput = this.dateRange.to.split("-");
                this.max_date = dateinput.join('/');
                console.log(this.min_date + this.max_date)
                this.roas = this.data_temp.roas;
                this.chartData = this.roas;
                this.dateValue = this.dateRange.from + " to " + this.dateRange.to
                //filtering data for graph
                let data1 = result.map((item) =>
                    item.clicks
                );
                this.clicksList = data1;
                let data2 = result.map((item) =>
                    item.impressions
                );
                this.impressionsList = data2;
                let data3 = result.map((item) =>
                    item.Orders
                );
                this.ordersList = data3
                let data4 = result.map((item) =>
                    item.adSales
                );
                this.adSalesList = data4;
                let data5 = result.map((item) =>
                    item.cpc
                );
                this.cpcList = data5;
                let data6 = result.map((item) =>
                    item.AdCost
                );
                this.adcostList = data6
                let data7 = result.map((item) =>
                    item.Keywords
                );
                this.keywordList = data7
                let data8 = result.map((item) =>
                    item.ROAS
                );
                this.roasList = data8
                let data9 = result.map((item) =>
                    item.unitsSold
                );
                const email = this.$store.state.credentials['attributes']['email'];
                this.unitsSoldList = data9
                this.top5cost = top5cost.costs;
                if (email === 'support@uniqin.ai') {
  
                    this.top5Keywords_sales = ['Targetting 1', 'Targetting 2', 'Targetting 3', 'Targetting 4', 'Targetting 5'];
                    } else {
                        this.top5Keywords_sales = top5_sales.keywords;
                    }
                
                this.top5_sales = top5_sales.sales;
                if (email === 'support@uniqin.ai') {
                
                this.top5Keywords = ['Targetting 1', 'Targetting 2', 'Targetting 3', 'Targetting 4', 'Targetting 5'];
                } else {
                    this.top5Keywords = top5cost.keywords;
                }
                // this.top5Keywords = top5cost.keywords;
                this.campaignName = this.data_temp['campaigns'];
                this.campaignName.push("all");
                //assigning default values to graph
                this.chartOptions1 = {
                    chart: {
                        type: 'donut',
                    },
                    labels: this.top5Keywords_sales,
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },
                    this.series1 = this.top5_sales,
                    console.log("chai ",this.top5_sales)
                    console.log("products",this.top5Keywords_sales)
                    this.chartOptions2 = {
                        chart: {
                            type: 'bar',
                        },
                        plotOptions: {
                            bar: {
                                borderRadius: 4,
                                horizontal: true,
                            }
                        },
                        dataLabels: {
                            enabled: false
                        },
                        xaxis: {
                            categories: this.top5Keywords
                        }
                    },
                    this.series2 = [{
                        name: 'Cost',
                        data: this.top5cost
                    }],
                    this.chartOptions3 = {
                        chart: {
                            height: 350,
                            type: "radialBar"
                        },
                        plotOptions: {
                            radialBar: {
                                startAngle: -90,
                                endAngle: 90,
                                dataLabels: {
                                    total: {
                                        show: true,
                                        label: this.chartData,
                                        formatter: function () {
                                            return ""
                                        }
                                    },
                                }
                            }
                        }
                    },
                    this.series3 = [(this.roas * 100 / 5)],
                    this.$q.loading.hide();
            }).catch(() => {
        this.$router.push("/home/" + this.$org_encryprt.label);
      });
        this.$q.loading.hide();
    },
    methods: {
        getEmailbasedTargetting(i) {
    const email = this.$store.state.credentials['attributes']['email'];
    if (email === 'support@uniqin.ai') {
        return `Targetting ${i + 0}`;
    } else {
        return this.keywordList[i - 1]; // Change i to index here
    }
},
        generatePDF() {
            const element = document.getElementById('screenshot');

            const scale = window.devicePixelRatio;
            const options = {
                scale: scale
            };

            html2canvas(element, options).then(canvas => {
                const pdf = new jsPDF();
                const imgData = canvas.toDataURL('image/png', 1.0);
                const imgProps = pdf.getImageProperties(imgData);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const ratio = imgProps.height / imgProps.width;
                const imgWidth = pdfWidth;
                const imgHeight = pdfWidth * ratio;
                pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);


                pdf.save("Report.pdf");
                //console.log(pdf);
                // var formData1 = new FormData();
                // formData1.append('file');
            });
        },
        sendMail() {

            this.$q.loading.show({
                message: "Sending Mail...",
            });
            const element = document.getElementById('screenshot');
            const scale = window.devicePixelRatio;
            const options = {
                scale: scale
            };
            html2canvas(element, options).then(canvas => {
                const pdf = new jsPDF();
                const imgData = canvas.toDataURL('image/png', 1.0);
                let postURL = this.api_url + `/amazon-ad/amazonadperformance/uploadfile/` + this.$org_id.label;
                //console.log(postURL)
                this.$http
                    .post(postURL, [{ 'dataUrl': imgData }])
                    .then((response) => {
                        this.$q.loading.hide();
                        //console.log(response)
                        this.seamless = true;

                    });

            });
        },
        optionsFn(dateRange) {
            return dateRange >= this.min_date && dateRange <= this.max_date
        },
        defaultCall() {
            return [
                {
                    start_date: null,
                    end_date: null,
                    campaign: 'all',
                    org_id: (this.$org_id.label).toString(),
                },
            ]
        },
        Backendcall() {
            return [
                {
                    start_date: this.dateRange.from,
                    end_date: this.dateRange.to,
                    campaign: this.campaign_name,
                    org_id: (this.$org_id.label).toString(),
                },
            ]
        },
        sortItemsByProp(option) {
            //table sort
            if (this.clickCount % 2 === 0) {
                var tableData = JSON.parse(JSON.stringify(this.tableData))
                var sortedArray = tableData.sort((a, b) => {
                    return a[option] - b[option]
                });
            }
            else {
                var tableData = JSON.parse(JSON.stringify(this.tableData))
                var sortedArray = tableData.sort((a, b) => {
                    return b[option] - a[option]
                });
            }
            this.clickCount++;
            this.tableData = sortedArray;
            let data3 = sortedArray.map((item) =>
                item.Orders
            );
            this.ordersList = data3
            let data1 = sortedArray.map((item) =>
                item.clicks
            );
            this.clicksList = data1;
            let data2 = sortedArray.map((item) =>
                item.impressions
            );
            this.impressionsList = data2;
            let data4 = sortedArray.map((item) =>
                item.adSales
            );
            this.adSalesList = data4;
            let data5 = sortedArray.map((item) =>
                item.cpc
            );
            this.cpcList = data5;
            let data6 = sortedArray.map((item) =>
                item.AdCost
            );
            this.adcostList = data6
            let data7 = sortedArray.map((item) =>
                item.Keywords
            );
            this.keywordList = data7
            let data8 = sortedArray.map((item) =>
                item.ROAS
            );
            this.roasList = data8
            let data9 = sortedArray.map((item) =>
                item.unitsSold
            );
            this.unitsSoldList = data9
        },
        setDate() {
            this.dateValue = this.dateRange.from + " to " + this.dateRange.to
            this.apiCall(this.campaign_name);
        },
        setCampaignName(item) {
            this.$q.loading.show({
            });
            this.apiCall(item)
        },
        apiCall(item) {
            this.campaign_name = item;
            var productsURL = this.api_url + "/dashboard/ad_dashbrd2_get_data";
            this.$http.post(productsURL, this.Backendcall()).then((response) => {
                this.data_temp = response.data;
                this.data_temp = response.data;
                this.tableData = response.data['table_data'];
                let result = this.tableData;
                let top5cost = response.data['top_5_cost'];
                let top5_sales = response.data['top_5_sales'];
                this.roas = this.data_temp.roas;
                this.chartData = this.roas;
                this.dateValue = this.dateRange.from + " to " + this.dateRange.to
                let data3 = result.map((item) =>
                    item.Orders
                );
                this.ordersList = data3
                let data1 = result.map((item) =>
                    item.clicks
                );
                this.clicksList = data1;
                let data2 = result.map((item) =>
                    item.impressions
                );
                this.impressionsList = data2;
                let data4 = result.map((item) =>
                    item.adSales
                );
                this.adSalesList = data4;
                let data5 = result.map((item) =>
                    item.cpc
                );
                this.cpcList = data5;
                let data6 = result.map((item) =>
                    item.AdCost
                );
                this.adcostList = data6
                let data7 = result.map((item) =>
                    item.Keywords
                );
                this.keywordList = data7
                let data8 = result.map((item) =>
                    item.ROAS
                );
                this.roasList = data8
                let data9 = result.map((item) =>
                    item.unitsSold
                );
                this.unitsSoldList = data9
                this.top5cost = top5cost.costs;
                // this.top5Keywords_sales = top5_sales.keywords
                this.top5Keywords_sales = top5_sales.keywords
                this.top5_sales = top5_sales.sales;
                this.top5Keywords = top5cost.keywords
                this.series1 = this.top5_sales,
                    this.chartOptions1 = {
                        labels: this.top5Keywords_sales,
                        responsive: [{
                            breakpoint: 480,
                            options: {
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        }]
                    },
                    this.series2 = [{
                        name: 'Cost',
                        data: this.top5cost
                    }],
                    this.chartOptions2 = {
                        chart: {
                            type: 'bar',
                        },
                        plotOptions: {
                            bar: {
                                borderRadius: 4,
                                horizontal: true,
                            }
                        },
                        dataLabels: {
                            enabled: false
                        },
                        xaxis: {
                            categories: this.top5Keywords
                        }
                    },
                    this.series3 = [(this.roas * 100 / 5)],
                    this.chartOptions3 = {
                        chart: {
                            height: 350,
                            type: "radialBar"
                        },
                        plotOptions: {
                            radialBar: {
                                startAngle: -90,
                                endAngle: 90,
                                dataLabels: {
                                    total: {
                                        show: true,
                                        label: this.chartData,
                                        formatter: function () {
                                            return ""
                                        }
                                    },
                                }
                            }
                        }
                    },
                    this.$q.loading.hide();
            })
        },
    }
}
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");

body {
    font-family: "Montserrat", sans-serif !important;
}

.apexcharts-menu-icon,
.apexcharts-selection-icon {
    display: none;
}

.dateInput {
    width: 250px;
    background-color: white !important;
    box-shadow: 0px 4px 12px #00000033 !important;
}

.graph-1 {
    border-radius: 10px;
    margin-right: 20px;
    text-align: center;
    background-color: white;
    box-shadow: 0px 3px 6px #9BDDD3;
}

/* .body-table {
    max-height: 10px !important;
    overflow: scroll;
    scrollbar-width: none;
    /* Firefox */
/* -ms-overflow-style: none;
    &::-webkit-scrollbar {
        width: 0px;
    }
} */
.graph-1 h5 {
    margin-top: 5px;
    color: #102689;
    font-weight: bold;
}

/* .table-title {
    background-color: #102689;
    font-weight: 'bold';
    max-height: 320px !important;
    overflow: scroll;
    scrollbar-width: none;
    /* Firefox */
/* -ms-overflow-style: none;
    &::-webkit-scrollbar {
        width: 0px;
    }
} */
.table-heading {
    font-size: 22px;
    color: white !important;
    font-weight: bolder;
}

.table-heading .q-btn__wrapper:before {
    content: none !important;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: inherit;
    box-shadow: none !important;
    font-weight: bold;
}

.my-sticky-header-table-1 {
    height: 300px;
}

.my-sticky-header-table-1 .q-table__top,
.my-sticky-header-table-1 .q-table__bottom,
.my-sticky-header-table-1 thead tr:first-child th {
    background-color: #102689;
    color:white
}

.my-sticky-header-table-1 thead tr th {
    position: sticky;
    z-index: 1;
}

.my-sticky-header-table-1 thead tr:last-child th {
    /* height of all previous header rows */
    top: 48px;
}

.my-sticky-header-table-1 thead tr:first-child th {
    top: 0;
}

.my-sticky-virtscroll-table {
    /* height or max-height is important */
    height: 410px;
    /* this will be the loading indicator */
}

.my-sticky-virtscroll-table .q-table__top,
.my-sticky-virtscroll-table .q-table__bottom,
.my-sticky-virtscroll-table thead tr:first-child th {
    background-color: #fff;
}

.my-sticky-virtscroll-table thead tr th {
    position: sticky;
    z-index: 1;
}

.my-sticky-virtscroll-table thead tr:last-child th {
    /* height of all previous header rows */
    top: 48px;
}

.my-sticky-virtscroll-table thead tr:first-child th {
    top: 0;
}
.graphs{
    margin:10px;
}
</style>
